import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { ChargePointListChannelsColumn } from '@app/feature/charge-point/charge-point-list/charge-point-list-channels.column';
import { ChargePointListIdentityColumn } from '@app/feature/charge-point/charge-point-list/charge-point-list-identity.column';
import { ChargePointListModelColumn } from '@app/feature/charge-point/charge-point-list/charge-point-list-model.column';
import { ChargePointListNameColumn } from '@app/feature/charge-point/charge-point-list/charge-point-list-name.column';
import { ChargePointListTariffColumn } from '@app/feature/charge-point/charge-point-list/charge-point-list-tariff.column';

import { LocationChargePointListUpdateFormStep1SelectColumn } from './location-charge-point-list-update-form-step-1-select.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const locationChargePointListUpdateFormStep1ColumnHelper =
  createColumnHelper<GatewayChargePointModel>();

type ResourceColumnType = ColumnDef<GatewayChargePointModel, any>[];

export const LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_LIST: ResourceColumnType =
  [
    locationChargePointListUpdateFormStep1ColumnHelper.display(
      LocationChargePointListUpdateFormStep1SelectColumn,
    ),
    locationChargePointListUpdateFormStep1ColumnHelper.accessor(
      'identity',
      ChargePointListIdentityColumn,
    ),
    locationChargePointListUpdateFormStep1ColumnHelper.accessor(
      'name',
      ChargePointListNameColumn,
    ),
    locationChargePointListUpdateFormStep1ColumnHelper.accessor(
      'model',
      ChargePointListModelColumn,
    ),
    locationChargePointListUpdateFormStep1ColumnHelper.accessor(
      'channels',
      ChargePointListChannelsColumn,
    ),
    locationChargePointListUpdateFormStep1ColumnHelper.accessor(
      'tariff',
      ChargePointListTariffColumn,
    ),
  ];

export const LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_ID_LIST =
  LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_LIST.flatMap(
    (columnDef) => {
      if ('accessorKey' in columnDef) {
        return [columnDef.id ?? (columnDef.accessorKey as string)];
      }

      if (columnDef.id) {
        return [columnDef.id];
      }

      return [];
    },
  );

export const LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_ORDER = [
  ...LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_ID_LIST,
];

export const LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_VISIBILITY =
  LOCATION_CHARGE_POINT_LIST_UPDATE_FORM_STEP_1_COLUMN_ID_LIST.reduce(
    (columnVisibility, columnId) => {
      return { ...columnVisibility, [columnId]: true };
    },
    {},
  );
